import { apiFetch } from "../api";

export type AgentIconUploadResult = {
  uploadUrl: string;
  s3Key: string;
  publicUrl: string | null;
  expiresIn: number;
};

export type AgentIconPublishResult = {
  s3Key: string;
  publicUrl: string | null;
};

export type AgentIconUrlResult = {
  url: string;
  publicUrl: string | null;
  s3Key: string;
  expiresIn: number;
};

export async function prepareAgentIconUpload(input: {
  orgId: string;
  agentId?: string;
  filename: string;
  contentType: string;
  contentLength: number;
}): Promise<AgentIconUploadResult> {
  return apiFetch<AgentIconUploadResult>("/api/ocean/agent-icon/upload-url", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function publishAgentIcon(s3Key: string): Promise<AgentIconPublishResult> {
  return apiFetch<AgentIconPublishResult>("/api/ocean/agent-icon/publish", {
    method: "POST",
    body: JSON.stringify({ s3Key }),
  });
}

export async function resolveAgentIconUrl(s3Key: string): Promise<AgentIconUrlResult> {
  const q = new URLSearchParams({ s3Key });
  return apiFetch<AgentIconUrlResult>(`/api/ocean/agent-icon/url?${q.toString()}`);
}

export async function uploadAgentIconFile(input: {
  orgId: string;
  agentId?: string;
  file: File;
}): Promise<{ s3Key: string; publicUrl: string | null }> {
  const prep = await prepareAgentIconUpload({
    orgId: input.orgId,
    agentId: input.agentId,
    filename: input.file.name,
    contentType: input.file.type,
    contentLength: input.file.size,
  });
  const put = await fetch(prep.uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": input.file.type },
    body: input.file,
  });
  if (!put.ok) {
    throw new Error(`Upload S3 fallito (${put.status})`);
  }
  const published = await publishAgentIcon(prep.s3Key);
  return { s3Key: published.s3Key, publicUrl: published.publicUrl };
}
